import * as types from "../constants";

const initialState = {
  openTasks: [],
  completedTasks: [],
  employees: []
}

export default function reducer(state = initialState, actions){
  const { type, payload } = actions;

  switch(type){
    case types.CREATE_TASK:
    case types.GET_TASK:
    case types.COMPLETE_TASK:
      return{
        ...state,
        openTasks: payload.openTasks,
        completedTasks: payload.completedTasks
      }
    case types.GET_EMPLOYEES:
      return{
        ...state,
        employees: payload
      }
    default:
      return {
        ...state
      }
  }
}
